// The ported tabs of the legacy `school/reports/pdfreports` hub (exam.md 8.1).
// Numbers are the legacy's tab numbers so the mapping stays readable.
export const GET_EXAM_REPORT_SECTION_WISE = 'GET_EXAM_REPORT_SECTION_WISE' // tab 1
export const GET_EXAM_REPORT_MARKSHEET = 'GET_EXAM_REPORT_MARKSHEET' // tab 2
export const GET_EXAM_REPORT_CUMULATIVE_SECTION_WISE = 'GET_EXAM_REPORT_CUMULATIVE_SECTION_WISE' // tab 3
export const GET_EXAM_REPORT_ANALYSIS_STUDENT_WISE = 'GET_EXAM_REPORT_ANALYSIS_STUDENT_WISE' // tab 4
export const GET_EXAM_REPORT_ANALYSIS_SECTION_WISE = 'GET_EXAM_REPORT_ANALYSIS_SECTION_WISE' // tab 5
export const GET_EXAM_REPORT_TEST_REPORTS = 'GET_EXAM_REPORT_TEST_REPORTS' // tab 6
export const GET_EXAM_REPORT_HOMEWORK_REPORTS = 'GET_EXAM_REPORT_HOMEWORK_REPORTS' // tab 7
export const GET_EXAM_REPORT_GRADE_ANALYSIS_STUDENTS = 'GET_EXAM_REPORT_GRADE_ANALYSIS_STUDENTS' // tab 8
export const GET_EXAM_REPORT_GRADE_ANALYSIS = 'GET_EXAM_REPORT_GRADE_ANALYSIS' // tab 9
